import React, { useEffect, useState } from "react";
import { GridWrap } from "emotion-flex-grid";

import Search from "./Search";
import SearchDisplay from "./SearchDisplay";
import Tabs from "components/Tabs";
import SearchCollections from "./SearchCollections";
import { Wrapper } from "./styled";
import { getSearchCollections, searchOnSite } from "api/api";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { setLoading, setSearchedCollections, setSearchedRecipes } from "store/searchReducer";

const tabsNav = [
  {
    id: 1,

    text: "Recipes",
  },
  {
    id: 2,

    text: "Collections",
  },
];

const tabsContent = [
  {
    id: 1,
    content: <SearchDisplay />,
  },
  {
    id: 2,
    content: <SearchCollections />,
  },
];

const SearchContainer = () => {
  const router = useRouter();
  const [active, setActiveInternal] = useState(Number(router.query.tab) || 1);

  const dispatch = useDispatch();

  const setActive = (tab) => {
    router.push(
      {
        pathname: "/search",
        query: { ...router.query, page: 1, tab },
      },
      undefined,
      { shallow: true }
    );
    setActiveInternal(tab);
  };

  const { text, page } = router.query;
  useEffect(() => {
    if (text || page) {
      dispatch(setLoading(true));
      Promise.all([searchOnSite(text, page), getSearchCollections(text, page)])
        .then((res) => {
          dispatch(setSearchedRecipes(res[0].data));
          dispatch(setSearchedCollections(res[1].data));
          dispatch(setLoading(false));

          if (!res[0].data.count && res[1].data.count) setActive(2);
          else if (res[0].data.count && !res[1].data.count) setActive(1);
        })
        .catch(() => dispatch(setLoading(false)));
    }
  }, [text, page]);

  return (
    <>
      <GridWrap maxWidth="1050px">
        <Wrapper>
          <Search />
          <Tabs list={tabsNav} tabContent={tabsContent} active={active} setTab={setActive} isSpacer={false} />
        </Wrapper>
      </GridWrap>
    </>
  );
};

export default SearchContainer;
